import {Component,ViewChildren,QueryList, ElementRef} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {DeviceService} from "../../device/device.service";
import {LocalizationCodeService} from "../../localization-code/localization-code.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {DeviceGqlModel, LocalizationCodeItemModel} from "../../device/device.gql-model";
import {FilteredList} from "../../helpers/filtered-list";
import * as _ from "lodash";
import {toggleLoading} from "../../misc/loading.decorator";
import { AbstractControl, FormArray, FormGroup} from "@angular/forms";
import {AppSettingsService} from "../../app-settings/app-settings.service";
import { TARGET_SYSTEM } from "../../helpers/app-constants";


@Component({
  templateUrl: "./additional-device-information.template.pug",
  providers: [DeviceService, LocalizationCodeService],
})
export class AdditionalDeviceInfoComponent extends WorkflowStep {
  public isDeviceIndependent: boolean = false;
  devices: FilteredList<DeviceGqlModel> = new FilteredList<DeviceGqlModel>({
    searchKeys: ["deviceKey","originalSolutionKey", "productNumber", "productDescription", "friendlyName", "bundleNumber", "type"],
    exactMatchSearchKeys: ["id"],
    formKeys: [
      "id",
      "type",
      "productNumber",
      "originalSolutionKey",
      "friendlyName",
      "bundleNumberPrefix",
      "bundleNumber",
      "bundleNumberWithoutPrefix",
      "alreadyUsedQuantity",
      "disabled",
      "localizationCodes",
      "maisActive",
      "targetSystem",
      "isDeviceIndependent",
      "hasRecurringCharge"
    ],
    booleanFilters: [{
      caption: "Hide disabled devices",
      check: (item: DeviceGqlModel, value: boolean) => (value ? !item.disabled : true),
      value: false,
    }],
  });

  error: Error;
  private LOCALIZATION_CODES_MAX_SELECTION: number = 6;
  public loadScreen: boolean = false;
  public cacheDevices:any = [];
  bundleConfigChecked: boolean = true;
  por721: boolean = false;
  POR731: boolean = false;

  
getSapProviderContract(itsmExtendedChildren: any[]) {
  for(const data of itsmExtendedChildren) {
    if(data.item === "SAPPROVIDERCONTRACT") {
      return data;
    } 
  }
}

@toggleLoading("loadScreen")
@handleErrors()
async loadData() {
  this.loadScreen = true;
  if (this.isMaiDevice && this.devices.items) {
    this.devices.items = this.devices.items.filter(item => item.itsmExtendedChildren === 'MAI')
  }
  else if (!this.isMaiDevice && this.devices.items.length !== 0) {
    this.devices.items = this.cacheDevices;
  }
  else {
    const devices = await this.deviceService.listDevicesForProject(this.workflowTargetInfo.targetId);
    let por721_tmc = false;
    const isTargetSystemValid = false;
    if (isTargetSystemValid) {
      const [featurePermission] = await Promise.all([
        this.appSettingsService.getFeaturePermission("POR721_TMC")
      ]);
      por721_tmc = featurePermission;
    }
    this.por721 = por721_tmc;
    this.POR731 = await this.appSettingsService.getFeaturePermission("POR731_TMC");

    devices.forEach((d) => {

      if (d.type === "independent service" && this.POR731) {
        this.isDeviceIndependent = true;
      }
      if(d.itsmExtendedChildren) {
        const sapProviderContract = this.getSapProviderContract(d.itsmExtendedChildren);
        d.itsmExtendedChildren = sapProviderContract ? sapProviderContract.sapSvcTitleStatus : null;
      }
      const selectedLocalizationCodesTmp = _.cloneDeep(d.localizationCodes);
      const availableLocalizationCodesTmp = _.cloneDeep(d.availableLocalizationCodes);

      // TODO: Check if this may be reduced
      const localizationCodesTmp = [];
      availableLocalizationCodesTmp.forEach((alc) => {
        alc.selected = !!selectedLocalizationCodesTmp.find(slc => alc.id === slc.id);
        localizationCodesTmp.push(alc);
      });
      selectedLocalizationCodesTmp.forEach((slc) => {
        if (!localizationCodesTmp.find(t => slc.id === t.id)) {
          slc.selected = true;
          localizationCodesTmp.push(slc);
        }
      });
      d.localizationCodes = localizationCodesTmp;

      while (d.localizationCodes.length < this.LOCALIZATION_CODES_MAX_SELECTION) {
        d.localizationCodes.push(new LocalizationCodeItemModel());
      }
      d.maisActive = d.maisActive ? d.maisActive : false;
      // Set bundleConfigChecked to true by default if bundleNumber is empty
      if(this.por721) {
        d.bundleNumberWithoutPrefix = "";
        d.bundleConfigChecked = true;
        d.showBundleNumberPrefix = true;
        d.bundleNumberPrefix = "bundle";
        if (d.bundleNumber) {
          if (d.bundleNumber.startsWith("BD-")) {
            d.bundleConfigChecked = true;
            d.bundleNumberWithoutPrefix = d.bundleNumber.split("-")[1];
          } else if (d.bundleNumber.startsWith("CID-")) {
            d.bundleConfigChecked = false;
            d.bundleNumberPrefix = "config";
            d.bundleNumberWithoutPrefix = d.bundleNumber.split("-")[1];
          } else {
            d.bundleConfigChecked = true;
            d.bundleNumberWithoutPrefix = d.bundleNumber;
          }
        }
        if (!d.bundleNumber) {
          d.bundleConfigChecked = true;
          if (d.maisActive) {
            d.showBundleNumberPrefix = false;
          }
        }
      }
    });

    this.devices.items = devices;
    if (this.por721) {
    // Get the items FormArray
      const itemsArray = this.devices.form.get("items") as FormArray;
      // Loop over each AbstractControl in the FormArray
      itemsArray.controls.forEach((group: AbstractControl, index: number) => {
      // Get the device for this FormGroup
        const device = this.devices.filtered[index];

        if (device && device.maisActive) {
          const bundleNumberWithoutPrefixValue = group.get("bundleNumberWithoutPrefix").value;
          group.get("bundleNumberWithoutPrefix").disable();
          group.get("bundleNumberWithoutPrefix").setValue(bundleNumberWithoutPrefixValue);
        } else {
          group.get("bundleNumberWithoutPrefix").enable();
        }
      });
    }
    this.cacheDevices = devices;
  }
}

idTypeChanged(event: any, device: any) {
  device.bundleConfigChecked = event.target.value === "bundle";
}

async ready(workflowTargetInfo: WorkflowTargetInfoModel, extraData: any) {
  if (extraData.filter) {
    this.devices.setSearchText(extraData.filter);
  }

  this.loadData();
}

  public isMaiDevice: boolean = false;
  public maiCheckBoxValue(event) {
    this.isMaiDevice = event.target.checked;
    this.loadData();
  }

  @handleErrors()
  async save(): Promise<boolean> {
    const updatedItems = this.devices.form.value.items.map((item, index) => {
      if (item.maisActive) {
        delete item.maisActive;
        return {
          bundleNumber: item.bundleNumber,
        };
      }
      let bundleNumber = item.bundleNumber ? item.bundleNumber.trim() : "";
      if (this.por721) {
        bundleNumber = item.bundleNumberWithoutPrefix ? item.bundleNumberWithoutPrefix.trim() : "";
        if (bundleNumber && !bundleNumber.includes("BD-") && !bundleNumber.includes("CID-")) {
          if (item.bundleNumberPrefix && item.bundleNumberPrefix === "bundle") {
            bundleNumber = `BD-${item.bundleNumberWithoutPrefix}`;
          } else if(item.bundleNumberPrefix && item.bundleNumberPrefix === "config") {
            bundleNumber = `CID-${item.bundleNumberWithoutPrefix}`;
          }
        }
      }
      return {
        bundleNumber,
        friendlyName: item.friendlyName.trim(),
      };
    });

    this.devices.form.patchValue({
      items: updatedItems,
    });
    const devices = (this.devices.form.value || {}).items || [];
    let devicesResp = await this.deviceService.updateDevicesForProject(this.workflowTargetInfo.targetId, devices);
    if (this.por721) {
      devicesResp.forEach((d) => {
        // Set bundleConfigChecked to true by default if bundleNumber is empty
        d.bundleNumberWithoutPrefix = "";
        d.bundleConfigChecked = true;
        d.showBundleNumberPrefix = true;
        d.bundleNumberPrefix = "bundle";
        if (d.bundleNumber) {
          if (d.bundleNumber.startsWith("BD-")) {
            d.bundleConfigChecked = true;
            d.bundleNumberWithoutPrefix = d.bundleNumber.split("-")[1];
          } else if (d.bundleNumber.startsWith("CID-")) {
            d.bundleConfigChecked = false;
            d.bundleNumberPrefix = "config";
            d.bundleNumberWithoutPrefix = d.bundleNumber.split("-")[1];
          } else {
            d.bundleConfigChecked = true;
            d.bundleNumberWithoutPrefix = d.bundleNumber;
          }
        }
        if (!d.bundleNumber) {
          d.bundleConfigChecked = true;
          if (d.maisActive) {
            d.showBundleNumberPrefix = false;
          }
        }
      });
    }
    this.devices.items = devicesResp;

    return true;
  }

  checkDirty(): boolean {
    return this.devices.form.dirty;
  }

  autoSave(): Promise<boolean> {
    return this.save();
  }

  async fileUploaded() {
    await this.loadData();
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public deviceService: DeviceService,
    private appSettingsService: AppSettingsService,
  ) {
    super();
  }
}
